import React from 'react';
import './style.scss';

interface parameters {
    className: string;
}

const PromotionEntrance = ({ className }: parameters) => {
    const timestamp = Math.floor(new Date().getTime() / 1000);
    return (
        <div className={`${className} imageWrap`}>
            <a href="https://event.liontravel.com/zh-tw/campaign/hotsale/earlybird" target="_blank" rel="noreferrer">
                <img src={`https://static.liontech.com.tw/flightpics/ec/promotionentrance.jpg?timestamp=${timestamp}`} loading="lazy" alt="折扣碼行銷頁" />
            </a>
        </div>
    )
}

export default PromotionEntrance
